import { render, staticRenderFns } from "./giftcard-success.vue?vue&type=template&id=b823c0be&scoped=true"
import script from "./giftcard-success.vue?vue&type=script&lang=js"
export * from "./giftcard-success.vue?vue&type=script&lang=js"
import style0 from "./giftcard-success.vue?vue&type=style&index=0&id=b823c0be&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b823c0be",
  null
  
)

export default component.exports